import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteFourmreportsFromAPI, fetchFourmreportsFromAPI, downloadFileFromAPI, downloadFourmreportSummaryPDFFromAPI, downloadFourmreportSummaryExcelFromAPI } from "../../../services/FourmreportService";


export const fetchFourmreports = createAsyncThunk(
  "fourmreports/fetchFourmreports",
  async ({ page, perPage, search, columnFilters }, { rejectWithValue, signal }) => {
    try {
      const response = await fetchFourmreportsFromAPI(page, perPage, search, columnFilters, signal);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteFourmreport = createAsyncThunk(
  "fourmreports/deleteFourmreport",
  async (fourmreportId, { rejectWithValue }) => {
    try {
      const response = await deleteFourmreportsFromAPI(fourmreportId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);


// Download Forecast File
export const downloadFile = createAsyncThunk(
  "fourmreports/downloadFile",
  async ({ fileType, search }, { rejectWithValue }) => {
    try {
      const response = await downloadFileFromAPI(fileType, search);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to download forecast file.");
    }
  }
);

// Download 4M Stock Summary PDF
export const downloadFourmreportSummaryPDF = createAsyncThunk(
  "fourmreports/downloadFourmreportSummaryPDF",
  async ({ search }, { rejectWithValue }) => {
    try {
      const response = await downloadFourmreportSummaryPDFFromAPI(search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download 4M stock summary PDF.");
    }
  }
);

// Download 4M Stock Summary Excel
export const downloadFourmreportSummaryExcel = createAsyncThunk(
  "fourmreports/downloadFourmreportSummaryExcel",
  async ({ search }, { rejectWithValue }) => {
    try {
      const response = await downloadFourmreportSummaryExcelFromAPI(search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download 4M stock summary Excel.");
    }
  }
);


const fourmreportSlice = createSlice({
  name: "fourmreports",
  initialState: {
    fourmreports: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    fourmreportSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:"",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchFourmreport: (state, action) => {
      state.fourmreportSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFourmreports.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFourmreports.fulfilled, (state, action) => {
        const fourmreports = action.payload.reports;
        state.loading = false;
        state.fourmreports = fourmreports.data;
        state.currentPage = fourmreports.current_page;
        state.lastPage = fourmreports.last_page;
        state.perPage = fourmreports.per_page;
        state.firstItem = fourmreports.from; // ✅ Ambil `from` dari API
        state.totalCount = fourmreports.total;
      })
      .addCase(fetchFourmreports.rejected, (state, action) => {
        if (action.meta?.aborted) return;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteFourmreport.fulfilled, (state, action) => {
        state.fourmreports = state.fourmreports.filter(fourmreport => fourmreport.id !== action.payload);
      })
      .addCase(deleteFourmreport.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchFourmreport, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters } = fourmreportSlice.actions;
export default fourmreportSlice.reducer;
